import React, { useState } from 'react';
import { GridDeleteIcon, GridRenderCellParams, GridRowParams } from '@mui/x-data-grid';
import { Icon, IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';

import DialogOrganisatieActivate from '../../controls/dialogs/DialogOrganisatieActivate';
import { MijnOrganisatieListItem } from '../../../models/user/mijnOrganisatieListItem';
import { userManagementService } from '../../../services/user-management.service';


const MijnOrganisatiesActionMenu = ({
  params,
  onOrganisatieSimulation
}: {
  params: GridRenderCellParams<MijnOrganisatieListItem>;
  onOrganisatieSimulation: () => void;
}) => {
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedOrganisatie, setSelectedOrganisatie] = useState<MijnOrganisatieListItem>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const [open, setOpenDialogs] = useState({
    simulation: false,
  });

  // Handlers to open/close each dialog
  const openDialog = (dialog: keyof typeof open) => {
    // setSelectedId(id);
    setOpenDialogs((prev) => ({ ...prev, [dialog]: true }));
    handleCloseMenu();
  };

  const closeDialog = (dialog: keyof typeof open) => {
    setOpenDialogs((prev) => ({ ...prev, [dialog]: false }));
    setSelectedOrganisatie(undefined);
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>, organisatie: MijnOrganisatieListItem) => {
    if (organisatie) {
      setSelectedOrganisatie(organisatie);
      setAnchorEl(event.currentTarget);
    }
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    // setSelectedOrganisatie(null);
  };

  const handleConfirmSimulation = () => {
    if (selectedOrganisatie) {
      handleSimulation();
    }
    closeDialog('simulation');
  };

  // event
  const handleSimulation = async () => {
    const organisatie = params.row as MijnOrganisatieListItem;

    userManagementService.setStoredOrganisatie(organisatie);
    // Re-fetch organisaties to update the grid
    onOrganisatieSimulation();
    // navigate('/plannen');
    navigate(0);
    // window.location.reload();
  }

  return (
    <>
      <IconButton onClick={(e) => handleOpenMenu(e, params.row)}>
        <Tooltip title="Acties" placement="right" arrow>
          <Icon>more_vert</Icon>
        </Tooltip>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <MenuItem onClick={() => openDialog('simulation')}>
          <ListItemIcon>
            <Icon>rocket_launch</Icon>
          </ListItemIcon>
          Deze organisatie gebruiken
        </MenuItem>
      </Menu>

      {selectedOrganisatie && selectedOrganisatie.displayName && (
        <DialogOrganisatieActivate
            open={open.simulation}
            organisatieNaam={selectedOrganisatie.displayName.toString()}
            onClose={() => closeDialog('simulation')}
            onConfirm={handleConfirmSimulation}
          />
      )}
    </>
  );
};

export default MijnOrganisatiesActionMenu;
